import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e6f3e36e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e6f3e36e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f3e36e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6f3e36e')) {
      api.createRecord('e6f3e36e', component.options)
    } else {
      api.reload('e6f3e36e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e6f3e36e&scoped=true&", function () {
      api.rerender('e6f3e36e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commission/courtManage/index.vue"
export default component.exports